import { __awaiter, __generator, __read } from "tslib";
import { getDocumentLaunchUrlAndClickId } from '../utilities/getDocumentLaunchUrlAndClickId';
import { getCapabilitiesAndContext } from './getCapabilitiesAndContext';
export function getLaunchParams(contentLaunchParams) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, capabilities, context, correlationId, defaultLinkTarget, getAccessToken, inMockMode, jwtAuthEnabled, officeHomeApiRoot, preferredCulture, router, sessionId, uiContext, workload, identity, _b, webUrl, clickId;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getCapabilitiesAndContext()];
                case 1:
                    _a = _c.sent(), capabilities = _a.capabilities, context = _a.context, correlationId = _a.correlationId, defaultLinkTarget = _a.defaultLinkTarget, getAccessToken = _a.getAccessToken, inMockMode = _a.inMockMode, jwtAuthEnabled = _a.jwtAuthEnabled, officeHomeApiRoot = _a.officeHomeApiRoot, preferredCulture = _a.preferredCulture, router = _a.router, sessionId = _a.sessionId, uiContext = _a.uiContext, workload = _a.workload;
                    return [4 /*yield*/, context.getIdentity()];
                case 2:
                    identity = _c.sent();
                    _b = __read(getDocumentLaunchUrlAndClickId(contentLaunchParams, router.getCurrentRoute, workload, preferredCulture, sessionId, capabilities.outgoingLoginHintEnabled ? context.loginHint : undefined, identity.isMsa), 2), webUrl = _b[0], clickId = _b[1];
                    return [2 /*return*/, {
                            context: context,
                            correlationId: correlationId,
                            defaultLinkTarget: defaultLinkTarget,
                            getAccessToken: getAccessToken,
                            inMockMode: inMockMode,
                            jwtAuthEnabled: jwtAuthEnabled,
                            officeHomeApiRoot: officeHomeApiRoot,
                            router: router,
                            preferredCulture: preferredCulture,
                            sessionId: sessionId,
                            uiContext: uiContext,
                            workload: workload,
                            capabilities: capabilities,
                            webUrl: webUrl,
                            clickId: clickId,
                        }];
            }
        });
    });
}
//# sourceMappingURL=getLaunchParams.js.map